import { render } from "./PopUpRating.vue?vue&type=template&id=2f4f0f3a&scoped=true"
import script from "./PopUpRating.vue?vue&type=script&lang=js"
export * from "./PopUpRating.vue?vue&type=script&lang=js"

import "./PopUpRating.vue?vue&type=style&index=0&id=2f4f0f3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4f0f3a"]])

export default __exports__